
import React from 'react'

export default function PageHeading(props) {
  return (
    <>
   <div className="page-heading-container mt-5">
      <div className="align-items-center">
        <h1>{props.title}</h1>
      </div>
    </div>
    </>
  )
}
